import { TMeetingsAction, TMeetingsState } from './meetings.types'
import * as actionTypes from './meetings.actionTypes'

export const initialMeetingsState: TMeetingsState = {
  list: {},
  groupIds: [],
  groupList: {},
  session: null,
  total: 0
}

export const meetingsReducer = (
  state: TMeetingsState = initialMeetingsState,
  action: TMeetingsAction
): TMeetingsState => {
  switch (action.type) {
    case actionTypes.ENTER_EXTERNAL_MEETING_SUCCESS: {
      return {
        ...state,
        session: action.payload.admission
      }
    }

    case actionTypes.LEAVE_EXTERNAL_MEETING: {
      return {
        ...state,
        session: null
      }
    }

    case actionTypes.GET_MEETINGS_SUCCESS: {
      return {
        ...state,
        ...action.payload.meetings,
        total: action.payload.total
      }
    }
    default:
      return state
  }
}
